import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { Endpoint } from './../../../constants/endpoints';

export enum TypeRule {
  ONLY_VIEW = 'R',
  ALLOW_PRESCRIBE = 'S',
  ALLOW_PRESCRIBE_ROUTINE = 'D',
  NOT_VISUALIZE = 'N'
}

export type RuleGroup = TypeRule | null;

export interface CpoeConfigurations {
  orderDialysis: number;
  orderEnteralDiet: number,
  orderExam: number,
  orderFasting: number,
  orderGasTherapy: number,
  orderHemotherapy: number,
  orderHydricControl: number,
  orderInfantParenteral: number,
  orderInterventation: number,
  orderMaterial: number,
  orderMedicine: number,
  orderMilk: number,
  orderOralDiet: number,
  orderParenteral: number,
  orderPathologicAnatomy: number
  orderRecommendation: number,
  orderSupplement: number,
  ruleDialysis: RuleGroup,
  ruleEnteralDiet: RuleGroup,
  ruleExam: RuleGroup,
  ruleFasting: RuleGroup,
  ruleGasTherapy: RuleGroup,
  ruleHemotherapy: RuleGroup,
  ruleHydricControl: RuleGroup,
  ruleInfantParenteral: RuleGroup,
  ruleInterventation: RuleGroup,
  ruleMaterial: RuleGroup,
  ruleMedicine: RuleGroup,
  ruleMilk: RuleGroup,
  ruleOralDiet: RuleGroup,
  ruleParenteral: RuleGroup,
  rulePathologicAnatomy: RuleGroup,
  ruleRecommendation: RuleGroup,
  ruleSupplement: RuleGroup,
}

/*same values used in Oswald to set value of Identifiable components inside Sortable in cpoe-deck*/
export enum CpoeGroup {
  DIALYSIS = 'Dialysis',
  EXAMS_PROCEDURES = 'Exam',
  GASTHERAPY = 'Gastherapy',
  HEMOTHERAPY = 'Hemotherapy',
  INFUSIONS_MEDICINES = 'Infusion',
  NURSING_INTERVENTIONS = 'Interventation',
  NUTRITION = 'Nutrition',
  RECOMMENDATIONS = 'Recommendation'
}

export const CpoeExpressions: Record<CpoeGroup, string> = {
  [CpoeGroup.DIALYSIS]: 'title.form.dialysis.count',
  [CpoeGroup.EXAMS_PROCEDURES]: 'title.form.exams-procedures.count',
  [CpoeGroup.GASTHERAPY]: 'title.form.gasotherapy.count',
  [CpoeGroup.HEMOTHERAPY]: 'title.form.hemoterapy.count',
  [CpoeGroup.INFUSIONS_MEDICINES]: 'title.form.solution-medication.count',
  [CpoeGroup.NURSING_INTERVENTIONS]: 'title.form.nursing-interventations.count',
  [CpoeGroup.NUTRITION]: 'title.form.nutrition.count',
  [CpoeGroup.RECOMMENDATIONS]: 'title.form.recommendation.count'
};

export interface OrderGroup {
  group: CpoeGroup;
  order: number;
  view: boolean;
}

export enum NutritionType {
  FLUID_CONTROL = 'H',
  FASTING = 'J',
  ORAL_DIETS = 'O',
  ENTERAL_DIETS = 'E',
  SUPPLEMENTS = 'S',
  INFANT_MILKS_FORMULAS = 'L',
  ADULT_TPN = 'P',
  PEDIATRIC_TPN = 'I'
}

export function allowViewGroup(ruleGroup: RuleGroup): boolean {
  return ruleGroup == TypeRule.ALLOW_PRESCRIBE || ruleGroup == TypeRule.ALLOW_PRESCRIBE_ROUTINE || ruleGroup == TypeRule.ONLY_VIEW || ruleGroup == null;
}

export default class CpoeService {

  public static loadConfigurationsCpoe(): Promise<CpoeConfigurations> {
    return Promise.resolve(
      HttpService.get(
        Endpoint.CPOE_GET_CONFIGURATIONS, {}
      ).then(response => {
        return response.body as CpoeConfigurations;
      }))
  }

  public static getRevalidationRule(): Promise<number> {
    return Promise.resolve(
      HttpService.get(
        Endpoint.CPOE_GET_REVALIDATION_RULE, {}
      ).then(response => {
        return response.body as number;
      })
    )
  }
}
